import React, { useState, useEffect } from 'react';
import axios from 'axios';
const KitchenDropdown = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);
  const [dropdown,setdropdown]=useState([]);


  const [handleedit, seteditData] = useState({
    id: null,
    Kitchen_Shape_id: '',
    Wall: '',
    Feet: '',
  });

  const [showeditmodal, setshoweditmodal] = useState(false);

  const [formData, setFormData] = useState({
    Kitchen_Shape_id: '',
    Wall: '',
    Feet: '',
  });
  

  const fetchcategories=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/kitchen_dropdown');
     console.log(res.data);
     setCategories(res.data);
    }catch(e){
      setError(e.response?.data?.message || 'Save failed');
    }
  }

  const fetchdrop=async()=>{
    try{
     const res=await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/kitchen_calculator');
     console.log(res.data);
     setdropdown(res.data);
    }catch(e){
      setError(e.response?.data?.message || 'Save failed');
    }
  }
  
  useEffect(() => {
   fetchcategories();
   fetchdrop();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleOpenModal = () => {
    setFormData({
      Kitchen_Shape_id: '',
      Wall: '',
      Feet: '',
    });
    setShowModal(true);
    setError('');
  };
  const handlesave = async () => {
    setLoading(true);
    setError('');
    try {
      await axios.post('https://api.squareandangle.pranatigroup.in/api/admin/kitchen_dropdown', {
        Kitchen_Shape_id: formData.Kitchen_Shape_id,
        Wall: formData.Wall,
        Feet: formData.Feet,
      });
      setShowModal(false);
      setFormData({ Kitchen_Shape_id: '', Wall: '', Feet: '' });
      fetchcategories();
    } catch (e) {
      setError(e.response?.data?.message || 'Save failed');
    } finally {
      setLoading(false);
    }
  };


   const handleeditin = (item) => {
    seteditData({
      id: item.id,
      Kitchen_Shape_id: item.Kitchen_Shape_id,
      Wall: item.Wall,
      Feet: item.Feet,
    });
    setshoweditmodal(true);
   }
 
   const handledelete = async (id) => {
     setLoading(true);
    try {
      await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/kitchen_dropdown/${id}`);
      fetchcategories();
    } catch (e) {
      setError(e.response?.data?.message || 'Delete failed');
    } finally {
      setLoading(false);
    }
   }


const handleupdatecat = async () => {
     setLoading(true);
     setError('');
    try {
      await axios.put(`https://api.squareandangle.pranatigroup.in/api/admin/kitchen_dropdown/${handleedit.id}`, {
        Kitchen_Shape_id: handleedit.Kitchen_Shape_id,
        Wall: handleedit.Wall,
        Feet: handleedit.Feet,
      });
      fetchcategories();
      setshoweditmodal(false);
    } catch (e) {
      setError(e.response?.data?.message || 'Update failed');
      setshoweditmodal(false);
    } finally {
      setLoading(false);
    }
   }

  const stylesD = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 15px'
  };
  return (


     
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
 <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">          <h3 className="m-0">Kitchen Dropdown</h3>
          <button className="btn btn-primary" onClick={handleOpenModal}>+ Add New</button>
        </div>

        
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                <th>Kitchen Shape</th>
                <th>Wall</th>
                <th>Feet</th>
                

             <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
            
                {
                categories.length>0 ?(
                
                categories.map((item, index) => (
                <tr key={item.id}>
               
                  <td>{index +1}</td>
                  <td>{item.kichen_shape}</td>
                  <td>{item.Wall}</td>
                   <td>{item.Feet}</td>
                  
                   <td className="text-center">
                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={()=>handleeditin(item)}>Edit</button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => {
                      if (window.confirm('Are you sure you want to delete this record?')) {
                        handledelete(item.id);
                      }
                    }}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
                ):(
               <tr>
                <td colSpan="5" className="text-center text-muted">
                  No Kitchen Dropdown Data Found
                </td>
               </tr>
                )}
            </tbody>

            
           
          </table>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Category</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
               
                <select className="form-control mb-2" value={formData.Kitchen_Shape_id} onChange={(e) => setFormData({ ...formData, Kitchen_Shape_id: e.target.value })}>
                  <option value="">Select Kitchen Shape</option>
                  {dropdown.map((item)=>(
                    <option key={item.id} value={item.id}>{item.kichen_shape}</option>
                  ))}
                </select>
                <input
                  type="number"
                  className="form-control mb-2"
                  placeholder="Wall"
                  value={formData.Wall}
                  onChange={(e) => setFormData({ ...formData, Wall: e.target.value })}
                />
                <input
                  type="number"
                  className="form-control mb-2"
                  placeholder="Feet"
                  value={formData.Feet}
                  onChange={(e) => setFormData({ ...formData, Feet: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handlesave} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {showeditmodal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Category</h5>
                <button 
                  className="close" 
                  style={{ background: 'transparent', border: 'none', fontSize: '1.5rem' }} 
                  onClick={() => setshoweditmodal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
               
                <select className="form-control mb-2" value={handleedit.Kitchen_Shape_id} onChange={(e) => seteditData({ ...handleedit, Kitchen_Shape_id: e.target.value })}>
                  <option value="">Select Kitchen Shape</option>
                  {dropdown.map((item)=>(
                    <option key={item.id} value={item.id}>{item.kichen_shape}</option>
                  ))}
                </select>
                <input
                  type="number"
                  className="form-control mb-2"
                  placeholder="Wall"
                  value={handleedit.Wall}
                  onChange={(e) => seteditData({ ...handleedit, Wall: e.target.value })}
                />
                <input
                  type="number"
                  className="form-control mb-2"
                  placeholder="Feet"
                  value={handleedit.Feet}
                  onChange={(e) => seteditData({ ...handleedit, Feet: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setshoweditmodal(false)}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleupdatecat} disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default KitchenDropdown;